<template>
   <div>
      <h3 class="section-title" id="states">State Appointment &amp; Fees</h3>

      <p class="instructions">
         Fees, if they exist, may be different for residents and non-residents. Please ensure you've entered your home 
         address on the "personal information" section so your residence can be confirmed.
      </p>

      <section-bar>
         <div class="float-right" id="states" v-if="$parent.readOnly()==null"><a href="#" class="ml-white add-state-link" @click.prevent="addState">
            <i class="fas fa-plus"></i> 
            Add a State
         </a></div>
         Selected States to be Appointed In
      </section-bar>
      
      <table class="table table-condensed table-striped font-smaller">
         <thead>
            <tr>
               <th>Selected State</th>
               <th class="text-right">Fees</th>
               <th class="text-center" v-if="$parent.readOnly()==null">Action</th>
            </tr>
            <tr v-for="itm in stateList" :key="itm.stateId">
               <td>{{itm.stateName}}</td>
               <td class="text-right">$ {{itm.feeAmount==null ? 0 : itm.feeAmount | twoplaces}}</td>
               <td class="text-center" v-if="$parent.readOnly()==null">
                  <button type="button" class="ml-red ml-h-black" v-tooltip:right="'Delete State'" @click.prevent="deleteState(itm)">
                     <i class="fas fa-times"></i>
                  </button>
               </td>
            </tr>
         </thead>
         <tbody>
            
            <tr v-if="showAddRow">
               <td>
                  <div class="dropdown add-state-btn">
                     <button type="button" class="btn dropdown-toggle the-button" data-toggle="dropdown">
                        <span class="fas fa-caret-down"></span>
                        {{ stateText() }}
                     </button>
                     <ul class="dropdown-menu shadow">
                        <li v-for="(itm, index) in fees" :key="itm.stateFeeId">
                           <a class="dropdown-item" href="#" @click.prevent="handleStateChange(itm)">
                              <div class="row">
                                 <div class="col-6">{{itm.stateName}}</div>
                                 <div class="col-3 text-right">{{itm.residentFeeAmount | twoplaces}}</div>
                                 <div class="col-3 text-right">{{itm.nonResidentFeeAmount | twoplaces}}</div>
                              </div>
                           </a>
                           <div class="dropdown-divider" v-if="index != fees.length-1"></div>
                        </li>
                     </ul>
                  </div>

               </td>
               <td class="text-right">$ {{selectedFee() | currency}}</td>
               <td class="text-center">
                  <button type="button" class="ml-red ml-h-black" v-tooltip:right="'Cancel'" @click.prevent="abortAdd">
                     <i class="fas fa-times"></i>
                  </button>
                  <button type="button" class="ml-corp ml-h-orange" v-tooltip:right="'Add this state'" @click.prevent="confirmAdd">
                     <i class="fas fa-check"></i>
                  </button>
               </td>
            </tr>
         </tbody>
         <tfoot>
            <tr>
               <td >
                  <div class="error--msg err-box" v-if="v$.states.$error">
                     {{ $parent.errorText(v$.states) }}
                  </div>
               </td>
               <td colspan="2" class="text-right font-smaller">
                  Total Amount = $ {{totalFees | twoplaces}}
               </td>
            </tr>
         </tfoot>
      </table>

      <p v-if="residentState!= ''">Your resident State Is '{{residentState}}'</p>

      <div class="alert alert-warning" role="alert">
         <button type="button" class="close" data-dismiss="alert" aria-label="close">
            <span aria-hidden="true">&times;</span>
         </button>
         <i class="fas fa-exclamation-triangle"></i>
         Please Note: We do not charge appointment fees until the first
         piece of business is made in that state.
      </div>

      <fieldset class="border p-2 marb-12" v-if="showType(['R'])">
         <legend class="w-auto">Pay Fees By Credit Card</legend>

         <div class="form-group row">
            <label for="creditCardTypeCode" class="col-sm-2 col-form-label" :class="{ 'error--label': v$.ccInfo.creditCardTypeCode.$error }">Credit Card Type</label>
            <div class="col-sm-4">
               <select class="form-control" id="ccInfo.creditCardTypeCode" :disabled="$parent.readOnly()" @blur="v$.ccInfo.creditCardTypeCode.$touch"
                  v-model="ccInfo.creditCardTypeCode" @change="chg" :class="{ 'error--input': v$.ccInfo.creditCardTypeCode.$error }">
                  <option :value="null" disabled hidden>(card type)</option>
                  <option value="CCTYP_MASTER">MasterCard</option>
                  <option value="CCTYP_VISA">Visa</option>
                  <option value="CCTYP_OTHER">Other</option>                  
               </select>
               <div class="error--msg" v-if="v$.ccInfo.creditCardTypeCode.$error">
                  {{ $parent.errorText(v$.ccInfo.creditCardTypeCode) }}
               </div>
            </div>
            <field-col name="ccInfo.cardNumber" label="Credit Card Number" v-model="ccInfo.cardNumber" :v$="v$.ccInfo.cardNumber" @change="chg" lcols="2" icols="4"></field-col>
         </div>   
         <div class="form-group row">
            <label for="expirationMonth" class="col-sm-2 col-form-label" :class="{ 'error--label': v$.ccInfo.creditCardTypeCode.$error }">Expiration Month/Year</label>
            <div class="col-sm-4">
               <select class="form-control" style="width: 90px !important; display: inline-block !important" aria-placeholder="(month)" id="ccInfo.expirationMonth" 
                  :disabled="$parent.readOnly()" @blur="v$.ccInfo.expirationMonth.$touch"
                  v-model.number="ccInfo.expirationMonth" @change="chg" :class="{ 'error--input': v$.ccInfo.expirationMonth.$error }">
                  <option :value="null" disabled hidden>(MM)</option>
                  <option v-for="m in expirationMonths()" :key="m" :value="m">{{(m).toString().padStart(2, "0")}}</option>
               </select>&nbsp;
               <select class="form-control" style="width: 130px !important; display: inline-block !important" id="expirationYear" 
                  :disabled="$parent.readOnly()" @blur="v$.ccInfo.expirationYear.$touch"
                  v-model="ccInfo.expirationYear" @change="chg" :class="{ 'error--input': v$.ccInfo.expirationYear.$error }">
                  <option :value="null" disabled hidden>(YYYY)</option>
                  <option v-for="y in expirationYears()" :key="y" :value="y">{{y}}</option>
               </select>
               <div class="error--msg" v-if="v$.ccInfo.expirationMonth.$error || v$.ccInfo.expirationYear.$error">
                  {{ $parent.errorText(v$.ccInfo.expirationMonth) }} {{ $parent.errorText(v$.ccInfo.expirationYear) }}
               </div>
            </div>
            <field-col name="ccInfo.cvcNumber" label="CVC Number" v-model="ccInfo.cvcNumber" :v$="v$.ccInfo.cvcNumber" @change="chg" lcols="2" icols="4"></field-col>
         </div>
         <div class="form-group row">
            <field-col name="ccInfo.nameonCard" label="Name On Card" v-model="ccInfo.nameonCard" :v$="v$.ccInfo.nameonCard" @change="chg" lcols="2" icols="8"></field-col>
         </div>
         <div class="form-group row">
            <field-col name="ccInfo.billingAddress" label="Billing Address" v-model="ccInfo.billingAddress" :v$="v$.ccInfo.billingAddress" @change="chg" lcols="2" icols="4"></field-col>
            <field-col name="ccInfo.city" label="City" v-model="ccInfo.city" :v$="v$.ccInfo.city" @change="chg" lcols="2" icols="4"></field-col>
         </div>
         <div class="form-group row">
            <label for="ccInfo.stateCode" class="col-sm-2 col-form-label" :class="{ 'error--label': v$.ccInfo.stateCode.$error }">State</label>
            <div class="col-sm-4">
               <select class="form-control" id="ccInfo.stateCode" aria-placeholder="(choose a state)"  @blur="v$.ccInfo.stateCode.$touch"
                  v-model="ccInfo.stateCode" @change="chg" :class="{ 'error--input': v$.ccInfo.stateCode.$error }" :disabled="$parent.readOnly()">
                  <option :value="null" disabled hidden>(choose a state)</option>
                  <option value="AA">Asia</option>
                  <option value="AK">Alaska</option>
                  <option value="AL">Alabama</option>
                  <option value="AR">Arkansas</option>
                  <option value="AS">American Samoa</option>
                  <option value="AZ">Arizona</option>
                  <option value="BC">British Columbia</option>
                  <option value="CA">California</option>
                  <option value="CM">Northern Mariana Islands</option>
                  <option value="CN">Canada</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DC">District of Columbia</option>
                  <option value="DE">Delaware</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="GU">Guam</option>
                  <option value="HI">Hawaii</option>
                  <option value="IA">Iowa</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="LT">Latin America</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MD">Maryland</option>
                  <option value="ME">Maine</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MO">Missouri</option>
                  <option value="MS">Mississippi</option>
                  <option value="MT">Montana</option>
                  <option value="NB">New Brunswick</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="NE">Nebraska</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NV">Nevada</option>
                  <option value="NY">New York</option>
                  <option value="OC">Foreign Country</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="PR">Puerto Rico</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VA">Virginia</option>
                  <option value="VI">Virgin Islands</option>
                  <option value="VT">Vermont</option>
                  <option value="WA">Washington</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WV">West Virginia</option>
                  <option value="WY">Wyoming</option>
               </select>
               <div class="error--msg" v-if="v$.ccInfo.stateCode.$error">
                  {{ $parent.errorText(v$.ccInfo.stateCode) }}
               </div>
            </div>
            <field-col name="ccInfo.zip" label="Zip Code" v-model="ccInfo.zip" :v$="v$.ccInfo.zip" @change="chg" lcols="2" icols="4"></field-col>
         </div>
      </fieldset>
      <p v-else><strong>Appointment Fees, if any, will be deducted from Commissions.</strong></p>

      <section-bar>Applicant's Signature</section-bar>
      <p class="instructions">Please enter your mother's maiden name indicating agreement with the above fees.</p>
      <div class="form-group row" v-if="!gettingSigs">
         <label for="feeMmName" class="col-sm-4 col-form-label"
             :class="{ 'error--label': v$.signatures.hasSigFees.$error }">Mother's Maiden Name</label>
         <div class="col-sm-4">
            <input type="text" class="form-control" id="feeMmName" placeholder="(mother's maiden name)" :readonly="$parent.readOnly()"
               v-model="signatures[feesig].signatureValue" @change="chg" @blur="v$.signatures.$touch()" 
               :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigFees.$invalid }">
            <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigFees.$invalid">
               {{ v$.signatures.hasSigFees.$message }}
            </div>
         </div>
      </div>

   </div>
</template>

<script>
import FieldCol from "../fieldCol.vue";

export default {
   name: "comp",
   components: {
      'field-col': FieldCol
   },
   props: { 
      'residentState': String,
      'apptType': String,
      'apptId': Number,
      'sigs': Array,
      'v$': Object,
      'ccardInfo': Object,
      'states': Array
   },
   data() {
      return {
         showAddRow: false,
         selectedStateId: null,
         totalFees: 0.00,
         fees: [],
         selectedState: null,
         signatures: [],
         stateList: [],
         gettingSigs: true,
         feesig: null,
         ccInfo: {}
      };
   },
   async mounted() {
      this.$parent.$parent.loadingStart()
      this.gettingSigs = true
      this.fees = await this.$appoint.getFees()
      this.stateList = []
      this.states.forEach(i => { this.stateList.push(i)})
      this.calcFees()
      this.signatures = JSON.parse(JSON.stringify(this.sigs)) //deep copy
      this.storeSignatures()
      this.gettingSigs = false
      this.v$.signatures.$touch()
      if (this.apptType=="APPTTYP_REP")
      {
         if (this.ccardInfo == null)
         {
            this.ccInfo = {
               creditCardTypeCode : null,
               cardNumber : '',
               expirationMonth : null,
               expirationYear : null,
               nameonCard : '',
               billingAddress : '',
               city : '',
               stateCode : null,
               zip : ''
            }
         } else {
            this.ccInfo = JSON.parse(JSON.stringify(this.ccardInfo)) //deep copy
         }
      }
      this.chg()
      this.$parent.$parent.loadingEnd()
   },
   methods: {
      expirationYears() {
         let yr = (new Date()).getFullYear()
         let arr = []
         for(let i=0; i<20; i++) {
            arr.push(yr + i)
         }
         return arr
      },
      expirationMonths() {
         let arr = []
         for(let i=1; i<13; i++) {
            arr.push(i)
         }
         return arr
      },
      addState() {
         this.showAddRow = true;
         this.chg()
      },
      abortAdd() {
         this.showAddRow = false;
         this.chg()
      },
      confirmAdd() {
         if (this.selectedState == null) {
            this.$swal(
               "Add What State",
               "Please make a selection from the State dropdown before clicking the check-mark.",
               "warning"
            );
            return
         }
         //Ensure state is not already configured
         let obj = this.stateList.filter(o => o.stateId == this.selectedState.stateId)
         if (obj && obj.length > 0) {
            this.$swal(
               "Already Configured",
               "Your selected state has already been added to the list.",
               "warning"
            );
            return
         }

         this.v$.states.$touch()

         let newRec = {
            stateId: this.selectedState.stateId,
            stateName: this.selectedState.stateName,
            feeAmount: this.selectedFee()
         }
         this.stateList.push(newRec)
         this.showAddRow = false;
         this.chg()
         this.calcFees()
         this.selectedState = null
      },
      deleteState(itm) {
         let indx = this.stateList.findIndex(item => item.stateId === itm.stateId)
         this.stateList.splice(indx, 1)
         this.calcFees()
         this.v$.states.$touch()
      },
      calcFees() {
         let tot = 0
         this.stateList.forEach(rec => {
            if (rec.feeAmount != null)
               tot += rec.feeAmount
         });
         this.totalFees = tot
         this.chg()
      },
      stateText() {
         if (this.selectedState==null) return '(Choose A State)'
         return this.selectedState.stateName
      },
      selectedFee() {
         if (this.selectedState==null) return 0
         if (this.selectedState.stateCode==this.residentState)
            return this.selectedState.residentFeeAmount
         else
            return this.selectedState.nonResidentFeeAmount
      },
      handleStateChange(itm) {
         this.selectedState = this.fees.filter(obj => { return obj.stateId === itm.stateId })[0]
      },
      signatureByType(typ) {
         if (this.signatures === undefined) return null
         let i = null
         this.signatures.forEach((element, indx) => {
            if (element.signatureTypeCode == typ) {
               i = indx
            }
         })
         return i
      },
      storeSignatures() {
         this.feesig = this.signatureByType('SIGTYP_ST_FEES')
         if (this.feesig==null) {
            let sig = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_ST_FEES',
               signatureValue: this.$store.getters.signature
            }
            this.feesig = this.signatures.length
            this.signatures.push(sig)
         } 
      },
      showType(tarr) {
         return this.$parent.showType(tarr, this.apptType)
      },
      // report the changes to the parent
      chg() {
         if (this.gettingSigs) return
         let rtn = { 
            states: this.stateList,
            signatures: this.signatures,
            ccInfo: this.ccInfo,
            showAddRow: this.showAddRow
         }
         this.$emit('update', rtn)
      }
   }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/colors.scss";
@import "../../assets/css/application.scss";
@import "../../assets/css/validation.scss";

.add-state-link {
   display:block;
   color: #fff;
   font-size: 0.7em;
   line-height: 0.7em;
   padding: 6px 6px 3px 12px;
}
.add-state-link:hover {
   font-weight: normal;
   color: #000;
}
.table button {
   padding: 0 6px;
   border-width: 0;
   background-color: transparent;
}
   .add-state-btn ul {
      list-style: none;
   }
   .add-state-btn .the-button {
      width: 100%;
      text-align: left;
      background-color: #fff;
      border: 1px solid #ddd;
      height: 28px;
      border-radius: 0px;
   }
   .add-state-btn .the-button:focus, .add-state-btn .the-button:active {
      outline: none !important;
      box-shadow: none !important;
   }
   .add-state-btn .dropdown-toggle::after {
      content: none;
   }
   .add-state-btn .fa-caret-down {
      margin-top: 3px;
      float: right;
      text-align:right;
   }
   .add-state-btn .dropdown-item i, button i:first-child {
      font-size: 1.3em;
      padding-right: 6px;
      min-width: 34px;
   }
   .add-state-btn a:hover {
      font-weight: normal;
   } 
   .add-state-btn .dropdown-menu {
      height:200px;
      overflow-y:auto;
   }
.err-box {
   background-color: #ffcccc;
   border: 1px solid #ff0000;
   border-radius: 4px;
   padding: 12px;
   display:inline-block;
}
.alert-warning {
   color: red;
}
.alert i {
   color: red;
   font-size: larger;
   padding-right: 12px;
}

</style>